"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PricingCTA() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="pricingcta" className="bg-[#08080e] py-[100px] w-full flex flex-col items-center justify-center overflow-hidden">
      <div className="page-container flex flex-col items-center text-center">
        <div ref={ref} className={`flex flex-col items-center w-full max-w-[800px] transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <h2 className="font-default font-extrabold text-white text-[clamp(36px,5vw,56px)] leading-[1.15] tracking-tight">
            Stop paying a designer. Start describing what you want.
          </h2>

          <p className="text-[#b0b0c8] text-[18px] max-w-[600px] mt-[16px] leading-[1.6]">
            Your first draft is free. Your final site is live in minutes.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mt-[32px] justify-center flex-wrap w-full">
            <Button asChild className="bg-[#3339F1] hover:bg-[#2a2eff] text-white px-8 py-3 font-semibold text-[16px] transition-all duration-200 hover:scale-105">
              <Link to="https://app.cynergia.co/sign-up">Start free trial</Link>
            </Button>

            <Button asChild className="bg-transparent border border-[rgba(255,255,255,0.2)] hover:bg-[rgba(255,255,255,0.05)] text-white px-8 py-3 font-semibold text-[16px] transition-all duration-200">
              <Link to="#" onClick={e => {
              e.preventDefault();
              window.location.href = "/contact";
            }}>
                Talk to our team
              </Link>
            </Button>
          </div>

          <p className="text-[#aaaacc] text-[13px] mt-[20px]">
            3-day free trial · No credit card · Cancel anytime
          </p>
        </div>
      </div>
    </section>;
}